import { render, staticRenderFns } from "./DeliveryOrder.vue?vue&type=template&id=2ecf93e1&scoped=true&"
import script from "./DeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrder.vue?vue&type=style&index=0&id=2ecf93e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecf93e1",
  null
  
)

export default component.exports